export enum DndSkinnyBannerCardFieldType {
  EditorContent = 'EditorContent',
  FrEditorContent = 'FrEditorContent',
  Url = 'Url',
  IsValid = 'IsValid',
  SubmitFormCallback = 'SubmitFormCallback',
}
